module.exports = __webpack_public_path__ + "static/JAN-22-Amarin-Harris-Poll-Infographic-The-Generational-Divide-bb0c110ca00964349592a89304666036.pdf";